import styled from 'styled-components'

import { NEUTRAL_COLOURS } from 'constants/colors'

import { getBrandingColor } from 'utils/branding'

export const StyledBanner = styled.div`
  background-color: ${getBrandingColor('primary-color-rgba-2')};
  padding: 8px 20px;
  margin: 18px -20px;
  font-size: 18px;
  font-weight: 600;
`

export const StyledDivider = styled.hr`
  border: 0 none;
  border-top: 1px solid ${NEUTRAL_COLOURS.SILVER};
  background: none;
  height: 0;
  margin: 24px -20px;
`
